import { format, differenceInMilliseconds } from 'date-fns'

export const LOCAL_DATE_FORMAT_SHORT = 'dd/MM/YY'
export const LOCAL_DATE_FORMAT = 'd MMM yyyy'
export const LOCAL_DATE_FORMAT_MONTH = 'MMMM'
export const LOCAL_DATE_FORMAT_MONTH_YEAR = 'MMM yyyy'
export const LOCAL_DATE_TIME_FORMAT = 'd MMM yyyy \u2022 h:mm a'

export const LOCAL_TIME_FORMAT = 'h:mm a'
export const LOCAL_TIME_DATE_FORMAT = 'h:mm a \u2022 d MMM yyyy'

export const formatTime = (date, formatProp) => {
  return date ? format(date, formatProp || LOCAL_TIME_FORMAT) : '-'
}

export const formatDate = (date, formatProp) => {
  return date ? format(date, formatProp || LOCAL_DATE_FORMAT) : '-'
}

export const formatDateTime = (date, formatProp) => {
  return date ? format(date, formatProp || LOCAL_DATE_TIME_FORMAT) : '-'
}

export const formatTimeDate = (date, formatProp) => {
  return date ? format(date, formatProp || LOCAL_TIME_DATE_FORMAT) : '-'
}

export const timeTo = (fromDate = new Date(), toDate = new Date()) => {
  if (!fromDate || !toDate) {
    return '-'
  }

  return differenceInMilliseconds(toDate, fromDate)
}



// WEBPACK FOOTER //
// ./src/utils/date.js